import { FC } from "react";
import useTabs from "../../../../../hooks/useTabs";
import useI18n from "../../../../../hooks/useTranslations";
import Tabs, { Tab } from "../../../../ui/Tabs";
import UprightMappings from "../uprightMappings/UprightMappings";
import UprightSpanMappings from "../uprightSpanMappings/UprightSpanMappings";

type Props = {
  // Passed down from BorderSystem: whether this Uprights tab is the active top-level tab.
  active?: boolean;
};

const SystemUprights: FC<Props> = ({ active }) => {
  const i18n = useI18n();

  const controller = useTabs(2, "u_tab");
  const isActiveTab = active ?? true;

  const contents = [
    <UprightMappings active={isActiveTab && controller.selectedIndex === 0} />,
    <UprightSpanMappings active={isActiveTab && controller.selectedIndex === 1} />,
  ];

  const tabs: Tab[] = [
    { title: i18n.translation.common.mappings },
    { title: i18n.translation.common.span },
  ];

  return (
    <Tabs.SubTab>
      <Tabs tabs={tabs} controller={controller} contents={contents} />
    </Tabs.SubTab>
  );
};

export default SystemUprights;
